import { PushMessageType } from 'types/pushMessage'

export const FETCH_PUSH_MESSAGES = 'FETCH_PUSH_MESSAGES'
export const fetchPushMessagesAction = (pushMessages: PushMessageType[]) => {
  return {
    type: 'FETCH_PUSH_MESSAGES',
    payload: pushMessages,
  }
}
